import { Pipe, PipeTransform } from '@angular/core';
import { parseISO, format, isValid, parse } from 'date-fns';
import { enGB, nl, fr } from 'date-fns/locale';
import { CultureEnum } from '@enums/culture.enum';
import { DateFormatEnum } from '@enums/date-format.enum';
import { TranslateService } from '@ngx-translate/core';
@Pipe({
  name: 'formatDate',
  pure: false,
})
export class FormatDatePipe implements PipeTransform {
  private locales: Record<string, any> = {
    [CultureEnum.enGB]: enGB,
    [CultureEnum.nlNL]: nl,
    [CultureEnum.nlBL]: nl,
    [CultureEnum.frFR]: fr,
  };

  private currentLang: string = CultureEnum.enGB;

  constructor(private translateService: TranslateService) {
    this.currentLang = this.translateService.currentLang || CultureEnum.enGB;
    this.translateService.onLangChange.subscribe((event) => {
      this.currentLang = event.lang as CultureEnum;
    });
  }

  transform(value: string): string {
    if (!value) {
      return '';
    }

    try {
      const locale = this.locales[this.currentLang] || enGB;

      if (this.isIsoDate(value)) {
        const date = parseISO(value);
        if (!isValid(date)) {
          return value;
        }
        return format(date, DateFormatEnum.ddMMyyyy, { locale });
      } else if (this.hasTextMonth(value)) {
        const parsedDate = parse(value, DateFormatEnum.textMonth, new Date());
        if (!isValid(parsedDate)) {
          return value;
        }
        return format(parsedDate, DateFormatEnum.textMonth, { locale });
      }

      return value;
    } catch (error) {
      return value;
    }
  }

  private isIsoDate(value: string): boolean {
    return /^\d{4}-\d{2}-\d{2}(T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[+-]\d{2}:\d{2})?)?$/.test(value);
  }

  private hasTextMonth(value: string): boolean {
    return /^[0-9]{1,2} [A-Za-z]{3} [0-9]{4}$/.test(value);
  }
}
